export default function Placeholder({ title, hint }: { title: string; hint: string }) {
  return (
    <div className="p-4 sm:p-6 lg:p-8 w-full">
      <h1 className="text-2xl font-semibold mb-2">{title}</h1>
      <p className="text-ink-muted mb-6">{hint}</p>
      <div className="bg-amber-950/30 border border-amber-900 text-amber-300 rounded p-4 text-sm">
        <strong>Phase 1 placeholder.</strong> UI for this screen lands in a follow-up push.
      </div>
    </div>
  );
}
